import type {
    Ajustes,
    CategoriaResumen,
    LayoutData,
    NavItem,
    SiteConfig
} from '@/types'

export const siteConfig: SiteConfig = {
    name: 'TROFÉA',
    description: 'Placas, trofeos, medallas y reconocimientos personalizados en Ecuador. Piezas de latón, acero, bronce, cristal y madera para premiar y conmemorar cada logro.',
    url: '',
    ogImage: 'https://trofea.cdn.modulify.website/sitio/hero-trofea.jpg',
    locale: 'es_EC'
}

export const mainNavigation: Array<NavItem> = [
    { label: 'Inicio', href: '/' },
    { label: 'Catálogo', href: '/catalogo' },
    { label: 'Servicios', href: '/servicios' },
    { label: 'Galería', href: '/galeria' },
    { label: 'Nosotros', href: '/nosotros' },
    { label: 'Contacto', href: '/contacto' }
]

export const quoteHref = '/cotizacion'

export const sectionImages = {
    hero: 'https://trofea.cdn.modulify.website/sitio/hero-trofea.jpg',
    personalizacion: 'https://trofea.cdn.modulify.website/sitio/personalizacion.jpg',
    servicios: 'https://trofea.cdn.modulify.website/sitio/servicios.jpg',
    nosotros: 'https://trofea.cdn.modulify.website/sitio/nosotros.jpg'
}

export const defaultAjustes: Ajustes = {
    id: null,
    descripcion_marca: 'Placas, trofeos, medallas y reconocimientos personalizados para celebrar los logros que merecen ser recordados.',
    correo: 'contacto@trofea.example',
    telefono: '+593 99 000 0000',
    whatsapp: '+593 99 000 0000',
    ubicacion: 'Ecuador',
    horario: 'Lunes a viernes, de 09:00 a 18:00',
    instagram_url: 'https://www.instagram.com/',
    facebook_url: 'https://www.facebook.com/',
    linkedin_url: 'https://www.linkedin.com/',
    tiktok_url: 'https://www.tiktok.com/',
    aviso_demo: 'TROFÉA es una marca de demostración. Los productos, imágenes, datos de contacto y ejemplos de este sitio son ilustrativos y no corresponden a una empresa real.'
}

export const defaultCategorias: Array<CategoriaResumen> = [
    { id: null, nombre: 'Placas', slug: 'placas' },
    { id: null, nombre: 'Trofeos', slug: 'trofeos' },
    { id: null, nombre: 'Medallas', slug: 'medallas' },
    { id: null, nombre: 'Reconocimientos', slug: 'reconocimientos' }
]

export const defaultLayoutData: LayoutData = {
    ajustes: defaultAjustes,
    categorias: defaultCategorias
}

export const revalidateSeconds = 60
